var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { AbstractRepository } from 'packages/core/AbstractRepository';
import { TalentComment } from 'packages/talent/entities/TalentComment';
import { EntityBuilder } from '@decahedron/entity';
import ENV from 'config/env';
import { User } from 'packages/users/User';
var CommentRepository = /** @class */ (function (_super) {
    __extends(CommentRepository, _super);
    function CommentRepository() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.baseUrl = ENV.JOBILLA_API_V2_URL;
        _this.url = 'talents/:talentId/';
        _this.entity = TalentComment;
        return _this;
    }
    CommentRepository.prototype.getComments = function (talentId, jobId) {
        var _this = this;
        return this.get("" + this.baseUrl + this.url + "comments", { talentId: talentId }, jobId ? { job_id: jobId } : null)
            .then(function (response) { return EntityBuilder.buildMany(TalentComment, _this.responseTransformer(response.data)); });
    };
    CommentRepository.prototype.getCommenters = function (talentId, jobId) {
        var _this = this;
        return this.get("" + this.baseUrl + this.url + "commenters", { talentId: talentId }, jobId ? { job_id: jobId } : null)
            .then(function (response) { return EntityBuilder.buildMany(User, _this.responseTransformer(response.data)); });
    };
    CommentRepository.prototype.postComment = function (talentId, body, jobId) {
        if (jobId === void 0) { jobId = null; }
        return this.post("" + this.baseUrl + this.url + "comments", { body: body, job_id: jobId }, { talentId: talentId });
    };
    CommentRepository.prototype.updateComment = function (body, commentId) {
        return this.put(this.baseUrl + "talents/comments/" + commentId, { body: body });
    };
    CommentRepository.prototype.deleteComment = function (commentId) {
        return this.axios.delete(this.baseUrl + "talents/comments/" + commentId);
    };
    return CommentRepository;
}(AbstractRepository));
export { CommentRepository };
